export default __webpack_public_path__ + "static/media/fog.bf7ce7ec.jpg";